import { Typography } from '@mui/material';
import { FC, useEffect } from 'react';
import PageIsLoading from 'src/components/PageIsLoading';
import EventsList from 'src/components/events/EventsList';
import { useGetAllEventsQuery } from 'src/features/events/eventsApiSlice';
import { EventsBreadCrumb } from '../components/events/EventsBreadCrumb';

const SiteIndex: FC<any> = () => {
    const { data: events = [], isLoading } = useGetAllEventsQuery();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    if (isLoading) {
        return <PageIsLoading />
    }

    const eventsToShow = events.filter(x => !x.parentEventId);
    if (eventsToShow.length === 0) {
        return (
            <Typography align='center' variant='h3'>(Det finns inget att visa här.)</Typography>
        )
    }

    return (
        <>
            <EventsBreadCrumb event={undefined} />
            <EventsList events={eventsToShow} />
        </>
    )

}



export default SiteIndex;
